import { IResortTopRated } from 'api/home/types';
import { Stars } from 'components/resort/Stars';
// import { useOTSTranslation } from 'i18n/useOTSTranslation';
import classNames from 'classnames';
import { NextLink } from 'components/blocks/NextLink';
import { useRef } from 'react';
import { Routes } from 'routes';
import DefaultImage from 'public/resort_header.jpg';
import { useVisibilityWindow } from 'util/useVisibilityWindow';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import { useBrandfolderOptimizedImage } from 'util/useBrandfolderOptimizedImage';
import styles from './styles.module.scss';

export const ResortInfo = ({
  data,
  isLoading,
  index,
}: {
  data: IResortTopRated,
  isLoading: boolean,
  index: number,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);
  // const { t } = useOTSTranslation('common');
  const optimizedImage = useBrandfolderOptimizedImage(data.resort.smallImage ? data.resort.smallImage : DefaultImage.src);
  const style = { backgroundImage: `url(${optimizedImage})` };

  return (
    <>
      <div className={classNames(styles.box, styles.resortCard, isLoading ? BLUR_CONTENT_STYLE_NAME : '')} ref={ref}>
        <div className={styles.imageWrapper}>
          <figure style={isVisible ? style : {}} tabIndex={-1} />
          <span className={styles.index}>{String(index).padStart(2, '0')}</span>
        </div>

        <div className={styles.content}>
          <div className={styles.titleRow}>
            <h3 className={styles.title}>
              {data.resort.title}
            </h3>

            <NextLink href={Routes.resortTripPlanningOverview(data.resortPath)}>
              <button type="button" className={styles.viewButton}>
                VIEW
              </button>
            </NextLink>
          </div>

          <div className={styles.stars}>
            <Stars amount={data.resort.rating} className={styles.starsBlue} starsBlue />
            <span>
              {data.resort.rating.toFixed(1)}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
